import React from "react";
import { Collapse, Grid, Typography } from "@material-ui/core";

import { isPasswordValid } from "../../../utils";
import PasswordRequirementValidatorItem from "./password-requirement-validator-item";

const PasswordRequirementValidator = ({ password }) => {
  const passwordValidation = isPasswordValid(password);

  return (
    <Collapse in={password.length > 0}>
      <Grid container direction="column" className="password-requirements">
        <Typography variant="caption">Password must include</Typography>
        <Grid item container direction="column" style={{ paddingLeft: 16 }}>
          <PasswordRequirementValidatorItem
            label="At least 8 characters"
            success={passwordValidation.hasMinLength}
          />
          <PasswordRequirementValidatorItem
            label="One uppercase or lowercase letter (A–Z, a–z)"
            success={passwordValidation.hasUpperOrLowercase}
          />
          <PasswordRequirementValidatorItem
            label="Two numbers or special characters (e.g. $#%)"
            success={passwordValidation.hasSpecialCharacters}
          />
        </Grid>
      </Grid>
    </Collapse>
  );
};

export default PasswordRequirementValidator;
